export interface UploadWallpaperResponse {
  success: boolean
  data: {
    id: string
    url: string
  }
}
